import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_ENDPOINT;

const createAsyncAction = (type, endpoint) => 
    createAsyncThunk(type, async (item, { getState, rejectWithValue }) => {
        try {
            const token = process.env.REACT_APP_DEALER_TOKEN;
            
            const response = await axios.post(`${API_URL}${endpoint}`, item, {
                headers: {
                    token: token
                }
            });

            return response.data;
        } catch (error) {
            console.error(`Error store ${type}:`, error.message);
            return rejectWithValue(error.response?.data || "Failed to create item");
        }
    });

export const createOneAccount = createAsyncAction(
    "v1/one-access",
    "/v1/one-access"
);

export const createToyotaID = createAsyncAction(
    "v1/toyota-id",
    "/v1/toyota-id"
);

export const fetchOneAccount = createAsyncThunk(
    "get-one-account",
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem("authToken");

            if (!token) {
                return rejectWithValue("Token not found");
            }

            const response = await axios.get(`${API_URL}/get-one-account`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data.data.data;
        } catch (error) {
            console.error("Error fetching one account data:", error);
            return rejectWithValue(
                error.response?.data || "Failed to fetch one account data"
            );
        }
    }
);

const oneAccount = createSlice({
    name: "oneAccount",
    initialState: {
        one_account: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createOneAccount.fulfilled, (state, action) => {
                state.isLoading = false;
                state.one_access_creation.push(action.payload.data);
            })
            .addCase(createToyotaID.fulfilled, (state, action) => {
                state.isLoading = false;
                state.toyota_id_creation.push(action.payload.data);
            })
            .addCase(fetchOneAccount.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchOneAccount.fulfilled, (state, action) => {
                state.isLoading = false;
                state.one_account = action.payload;
            })
            .addCase(fetchOneAccount.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
    },
});

export default oneAccount.reducer;
